// src/prompts/templates/analyzeSentiment.ts
var analyzeSentimentPrompt = [
  "You are a sentiment analysis expert.",
  "Analyze the sentiment of the given text.",
  'Respond with ONLY valid JSON in this exact format: {"sentiment": "positive"|"negative"|"neutral", "score": 0.0-1.0}'
].join("\n");

export {
  analyzeSentimentPrompt
};
